export const DEFAULT_DEBOUNCE_MS = 300;
